import { SampleCalcs } from '../models/calculate.model';
import { SampleSummaryResult } from '../models/result.model';
import { formatDiscardReason } from './discard-reason.util';

/** One row per replicate, carrying its sample's aggregates alongside. */
export function mapPlainRows(samples: SampleSummaryResult[]): SampleCalcs[] {
  return samples.flatMap(sample =>
    sample.individualReps?.map(rep => {
      const discard = formatDiscardReason(rep.isDiscarded, rep.discardReason, rep.isOutlier);

      return {
        isDiscarded: rep.isDiscarded,
        discardReason: discard.text,
        autoDiscarded: discard.source === 'auto',
        isOutlier: discard.source === 'outlier',
        accessionId: sample.accessionNo,
        resultStatus: sample.resultStatus,
        repNum: rep.repNum,
        updatedRepNum: rep.updatedRepNum,
        beadCV: rep.beadCV,
        beadCount: rep.beadCount,
        countTime: rep.countTime,
        rfi: rep.rfi,
        normalizingBeadSignal: rep.normalizingBeadSignal,
        calcFR: rep.fr,
        reqNumReplicates: sample.numReplicates ?? NaN,
        meanRFI: sample.meanRFI ?? NaN,
        meanNormalizingBeadSignal: sample.meanNormalizingBeadSignal ?? NaN,
        meanFR: sample.meanFR ?? NaN,
        instrumentConc: rep.instrumentConc ?? NaN,
        calculatedConc: rep.calculatedConc ?? NaN,
        finalValue: rep.instrumentConc ?? rep.calculatedConc ?? NaN,
        aveValue: sample.meanFinalConc ?? NaN,
        finalRepCount: sample.finalRepCount ?? NaN,
        repCountOk: sample.repCountOk ?? '',
        repSD: sample.repSD ?? NaN,
        repCV: sample.repCV ?? NaN,
        resultRepOK: sample.resultRepOk ?? '',
        formattedTestResult: sample.formattedTestResult ?? NaN,
        assignedValue: sample.assignedValue ?? NaN,
        assignedStatus: sample.assignedStatus ?? '',
        testStatus: sample.testStatus ?? '',
        testScore: sample.testScore ?? '',
        difference: sample.difference ?? NaN,
        percentDifference: sample.percentDifference ?? NaN,
        ratio: sample.ratio ?? NaN,
        averageBeadCV: sample.meanBeadCV ?? NaN,
        averageBeadCount: sample.meanBeadCount ?? NaN,
        averageCountTime: sample.meanCountTime ?? NaN
      };
    }) ?? []
  );
}
